module.exports = __webpack_public_path__ + "static/media/trips.8373073b.svg";